import { API_URL } from 'constants/api';
import {
  FunctionComponent,
  createContext,
  useState,
  useEffect,
  PropsWithChildren,
  useContext,
} from 'react';
import { ApiResponse } from 'types/api';
import { useCities } from './cities';
import { Category } from 'types/category';
import { useRevalidate } from 'hooks/useRevalidate';
import { wrappedFetch } from 'utils/api';

export const CategoriesContext = createContext<Category[]>([]);

export const useCategories = () => useContext(CategoriesContext);

interface CategoriesProviderProps extends PropsWithChildren {}

export const fetchCategories = (
  cityId: number,
): Promise<ApiResponse<Category[]>> => {
  return wrappedFetch(`${API_URL}categories/problem-types?cityId=${cityId}`);
};

const CategoriesProvider: FunctionComponent<CategoriesProviderProps> = ({
  children,
}) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const { isCityResolved, selectedCity } = useCities();
  const { data, mutate } = useRevalidate<Category[]>(
    `categories-${selectedCity?.id}`,
    0,
  );

  useEffect(() => {
    if (!isCityResolved || !selectedCity) {
      setCategories([]);

      return;
    }

    if (!data) {
      setCategories([]);

      fetchCategories(selectedCity.id).then((res) => {
        if ('data' in res) {
          setCategories(res.data);
          mutate(res.data);
        }
      });
    } else {
      setCategories(data);
    }
  }, [selectedCity, data, isCityResolved, mutate]);

  return (
    <CategoriesContext.Provider value={categories}>
      {children}
    </CategoriesContext.Provider>
  );
};

export default CategoriesProvider;
